import { createSelector } from 'reselect';

import { ExtensionKey } from 'flow/types/EntityKeys';
import { State } from 'flow/types/State';
import { selectIsAdmin } from './own-extension-selectors';
import { getOwnExtensionKey } from './selectors';

export const selectCustomer = (state: State, extensionKey: ExtensionKey) =>
    state.customer.get(extensionKey);

export const selectRetailerKey = (state: State, extensionKey: ExtensionKey) =>
    state.customer.getIn([extensionKey, 'retailer', 'key']);

export const selectLoggedInCustomer = (state: State) => {
    const customerEntityKey = getOwnExtensionKey(state);
    return state.customer.get(customerEntityKey);
};

export const selectOwnCustomerKey = (state: State) =>
    selectLoggedInCustomer(state)?.get('key');

export const selectCustomerCountry = (state: State) => {
    const customer = selectLoggedInCustomer(state);
    return customer?.getIn(['country', 'name']);
};

export const selectCustomerProductTypeIsBundle = (state: State) =>
    selectLoggedInCustomer(state)?.get('productType') === 'bundle';

export const canInviteColleagues = createSelector(
    [selectLoggedInCustomer, selectIsAdmin],
    (customer, isAdmin) => {
        const isPremiumCustomer = customer.get('premiumCustomer');

        return !isPremiumCustomer && isAdmin;
    },
);
